import React, { forwardRef } from "react";

const FacilitySection = forwardRef((props, ref) => {
  const { name, imageUrl } = props;
  return (
    <div className="facility-section" ref={ref}>
      <div className="facility-header">
        <h2>{name}</h2>
        <p>{props.imgDesc}</p>
      </div>
      <div className="facility-images">
        {imageUrl.map((list, index) => (
          <img key={index} src={list} alt={`${name}`} />
        ))}
      </div>
    </div>
  );
});

export default FacilitySection;
